import React from 'react';

// Small stroke-only SVGs used inside action buttons. They inherit `color`
// from the parent (via stroke="currentColor"), so a button's text color
// automatically colors the icon.

const wrap = {
  width: 16,
  height: 16,
  verticalAlign: '-3px',
  flexShrink: 0,
};

const svgProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
};

export const IconEye = (props) => (
  <svg {...svgProps} style={{ ...wrap, ...props?.style }}>
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

export const IconPlus = (props) => (
  <svg {...svgProps} style={{ ...wrap, ...props?.style }}>
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

export const IconPencil = (props) => (
  <svg {...svgProps} style={{ ...wrap, ...props?.style }}>
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z" />
  </svg>
);

export const IconTrash = (props) => (
  <svg {...svgProps} style={{ ...wrap, ...props?.style }}>
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" />
    <path d="M10 11v6" />
    <path d="M14 11v6" />
    <path d="M9 6V4a2 2 0 012-2h2a2 2 0 012 2v2" />
  </svg>
);
